(function () {
  'use strict';

  function playVideoInSlide(slide) {
    if (!slide) return;
    var dm = slide.querySelector('deferred-media');
    if (!dm) return;
    if (dm.getAttribute('loaded')) {
      if (window.pauseAllMedia) window.pauseAllMedia();
      var v = dm.querySelector('video');
      if (v) { v.muted = true; v.play().catch(function () {}); }
    } else if (typeof dm.loadContent === 'function') {
      dm.loadContent(false);
    }
  }

  function initGallery(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;

    // Sync vidéo lors du swipe mobile
    viewer.addEventListener('slideChanged', function (event) {
      var active = event.detail && event.detail.currentElement;
      if (active) playVideoInSlide(active);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('media-gallery').forEach(initGallery);
    });
  } else {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }
})();